export default __webpack_public_path__ + "static/media/1818.a65b3f6c.png";